import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <CardsSection />
        <FeaturesSection />
        <CommentsSection />
        <AppSection />
        <CarouselSection />
        <MediaSection />
        <ContactSection />
        <TopicsSection />
        <UpdatesSection />
        <FAQSection />
        <AboutSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}